import ENV from "../env";

async function restockStockItem({ stockItemId, quantity, venueId, createdBy, operationId }) {
  const response = await fetch(`${ENV.firebaseApiUrl}/stock/restock`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      stockItemId,
      quantity,
      operationId,
      venueId,
      createdBy,
    }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data?.error || "Restock failed");
}

export default restockStockItem;
